/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Rail_All_AlternativesInputs */

const en_directory_detail_rail_all_alternatives = /** @type {(inputs: Directory_Detail_Rail_All_AlternativesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All alternatives`)
};

const zh_directory_detail_rail_all_alternatives = /** @type {(inputs: Directory_Detail_Rail_All_AlternativesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部替代方案`)
};

/**
* | output |
* | --- |
* | "All alternatives" |
*
* @param {Directory_Detail_Rail_All_AlternativesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_rail_all_alternatives = /** @type {((inputs?: Directory_Detail_Rail_All_AlternativesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Rail_All_AlternativesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_rail_all_alternatives(inputs)
	return zh_directory_detail_rail_all_alternatives(inputs)
});
export { directory_detail_rail_all_alternatives as "directory.detail.rail.all_alternatives" }